export default (value, format) => {
  if (value == null || value === '') {
    return value
  }

  const date = new Date(value)

  if (format === undefined) {
    return formatDate(date, {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    })
  }

  if (format === 'month-year') {
    return formatDate(date, {
      month: 'long',
      year: 'numeric'
    })
  }

  if (format === 'time') {
    return formatDate(date, {
      hour: 'numeric',
      minute: 'numeric',
      hour12: false
    })
  }

  if (format === 'date-time') {
    return formatDate(date, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false
    })
  }
}

function formatDate (date, formatOptions) {
  return Intl.DateTimeFormat(
    process.env.I18N_NUMBER_FORMAT_LOCALE,
    formatOptions
  ).format(date)
}
